(() => {
  const initialize = () => {
    const article = document.querySelector('[data-journal-article]');
    if (!article || article.dataset.journalAnalyticsBound === 'true') return;
    const content = article.querySelector('[data-journal-content]');
    if (!content) return;
    article.dataset.journalAnalyticsBound = 'true';

    const commerceModules = Array.from(document.querySelectorAll('[data-journal-wear-story], .cl-journal-commerce'));
    const inCommerceScope = link => content.contains(link) || commerceModules.some(module => module.contains(link));
    const commerceLinks = Array.from(document.querySelectorAll('a[href]')).filter(inCommerceScope);

    const metadata = {
      article_id: String(article.dataset.journalId || '').slice(0, 30),
      article_slug: String(article.dataset.journalSlug || '').slice(0, 200),
      article_title: String(article.dataset.journalTitle || '').slice(0, 250)
    };
    const seenImpressions = new WeakSet();
    const pendingImpressions = new WeakSet();
    let impressionObserver;
    let readSent = false;
    let readPending = false;
    let hasScrolled = false;
    let framePending = false;

    const analyticsAllowed = () => {
      const privacy = window.Shopify?.customerPrivacy;
      if (typeof privacy?.analyticsProcessingAllowed !== 'function') return false;
      try {
        return privacy.analyticsProcessingAllowed() === true;
      } catch {
        return false;
      }
    };

    const emit = async (name, detail) => {
      if (!analyticsAllowed()) return false;
      const payload = { ...metadata, ...detail };
      let dispatched = false;
      if (typeof window.gtag === 'function') {
        try {
          window.gtag('event', name, payload);
          dispatched = true;
        } catch {}
      }
      const analytics = window.Shopify?.analytics;
      if (typeof analytics?.publish === 'function' && analyticsAllowed()) {
        try {
          const result = await analytics.publish(`claudio_lugli:${name}`, payload);
          dispatched = result !== false || dispatched;
        } catch {}
      }
      return dispatched;
    };

    const commerceLink = link => {
      if (!link || !inCommerceScope(link)) return null;
      const linkIndex = commerceLinks.indexOf(link);
      if (linkIndex < 0) return null;
      let url;
      try {
        url = new URL(link.getAttribute('href'), window.location.href);
      } catch {
        return null;
      }
      if (url.origin !== window.location.origin) return null;
      if (!/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?(?:products\/[^/]+|collections\/[^/]+(?:\/products\/[^/]+)?)\/?$/i.test(url.pathname)) return null;
      const placementElement = link.closest('[data-journal-placement], [data-cl-placement]');
      const placement = link.closest('[data-journal-wear-story]') ? 'wear_the_story' :
        placementElement?.dataset.journalPlacement || placementElement?.dataset.clPlacement ||
        (content.contains(link) ? 'article_body' : 'commerce_module');
      return {
        destination_path: url.pathname,
        placement: String(placement).replace(/[^a-z0-9_-]/gi, '_').slice(0, 80),
        destination_type: /\/products\//i.test(url.pathname) ? 'product' : 'collection',
        link_position: linkIndex + 1
      };
    };

    document.addEventListener('click', event => {
      const link = event.target instanceof Element ? event.target.closest('a[href]') : null;
      const detail = commerceLink(link);
      if (detail) void emit('journal_commerce_click', detail);
    });

    const checkReadProgress = async () => {
      if (!hasScrolled || readSent || readPending || !analyticsAllowed()) return;
      if (document.visibilityState !== 'visible') return;
      const bounds = content.getBoundingClientRect();
      if (bounds.height <= 0) return;
      const progress = (window.innerHeight - bounds.top) / bounds.height;
      if (progress < 0.5) return;
      readPending = true;
      try {
        if (await emit('journal_read', { progress_percent: 50 })) readSent = true;
      } finally {
        readPending = false;
      }
    };

    const synchronizeConsent = () => {
      if (!analyticsAllowed()) {
        impressionObserver?.disconnect();
        impressionObserver = undefined;
        hasScrolled = false;
        return;
      }
      if (!impressionObserver && typeof IntersectionObserver === 'function') {
        impressionObserver = new IntersectionObserver(entries => {
          for (const entry of entries) {
            if (!entry.isIntersecting || entry.intersectionRatio < 0.5 || !analyticsAllowed()) continue;
            if (document.visibilityState !== 'visible') continue;
            const link = entry.target;
            const detail = commerceLink(link);
            if (!detail || seenImpressions.has(link) || pendingImpressions.has(link)) continue;
            pendingImpressions.add(link);
            void emit('journal_commerce_impression', detail).then(dispatched => {
              if (dispatched) {
                seenImpressions.add(link);
                impressionObserver?.unobserve(link);
              }
            }).finally(() => pendingImpressions.delete(link));
          }
        }, { threshold: 0.5 });
        for (const link of commerceLinks) {
          if (commerceLink(link) && !seenImpressions.has(link)) impressionObserver.observe(link);
        }
      }
    };

    const handleScroll = () => {
      if (!analyticsAllowed()) {
        hasScrolled = false;
        return;
      }
      hasScrolled = true;
      if (framePending) return;
      framePending = true;
      window.requestAnimationFrame(() => {
        framePending = false;
        void checkReadProgress();
      });
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    window.addEventListener('resize', () => void checkReadProgress(), { passive: true });
    document.addEventListener('visitorConsentCollected', () => {
      hasScrolled = false;
      synchronizeConsent();
    });
    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'visible') {
        synchronizeConsent();
      } else {
        impressionObserver?.disconnect();
        impressionObserver = undefined;
      }
    });
    synchronizeConsent();

    if (!window.Shopify?.customerPrivacy && typeof window.Shopify?.loadFeatures === 'function') {
      try {
        window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], error => {
          if (!error) synchronizeConsent();
        });
      } catch {}
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
})();

